/** @format */

import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { FaMapMarkerAlt } from "react-icons/fa";
import { usePersonalizacao } from "../../context/usePersonalizacao";

export function LojaButton({ loja, ...props }) {
  const {
    personalizacao: { guiaofertas },
  } = usePersonalizacao();

  return (
    <Box
      display={guiaofertas.showLoja === undefined ? "flex" : !guiaofertas.showLoja ? "none" : "flex"}
      w="100%"
      flexDir="row"
      alignItems="center"
      justifyContent="center"
      padding="0.25rem"
      background={
        guiaofertas?.botaoloja?.background
          ? guiaofertas.botaoloja.background
          : "#E2F4FF"
      }
      cursor="pointer"
      transition="opacity 0.2s"
      borderRadius="full"
      _hover={[{ opacity: 0.8 }]}
      {...props}>
      <FaMapMarkerAlt
        color={
          guiaofertas?.botaoloja?.textcolor
            ? guiaofertas?.botaoloja?.textcolor
            : "#163466"
        }
        size={16}
        style={{ marginRight: 10 }}
      />

      <Text
        color={
          guiaofertas?.botaoloja?.textcolor
            ? guiaofertas?.botaoloja?.textcolor
            : "#163466"
        }
        fontWeight="semibold"
        fontSize="sm"
        textDecorationLine="underline">
        {loja ?? "Selecione uma loja"}
      </Text>
    </Box>
  );
}
